import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import './NavBar.scss';

import RouterLink from '../../ui/router-link/RouterLink';
import Icon from '../../ui/icon/Icon';

import routes from '../../../constants/routes.constant';
import socials from '../../../constants/social-media.constants';
import { getCart } from '../../../store/slices/cart.slice';
import { getFavorites } from '../../../store/slices/favorites.slice';

const NavBar: React.FC<any> = () => {
  const location = useLocation();

  const [activeRoute, setActiveRoute] = useState(routes[0]);

  useEffect(() => {
    const activeRoute = routes.filter(i => i.path === location.pathname);
    setActiveRoute(activeRoute.length > 0 ? activeRoute[0] : { path: '/', label: 'home' });
  }, [location]);

  const { orders } = useSelector(getCart);
  const { favorites } = useSelector(getFavorites);

  return (
    <>
      <div className="top-nav">
        <div className="top-nav__misc">
          <Icon className="language-icon" imgPath="/images/flags/us.png" />
          <label className="language-label">English</label>
          <label className="currency-label">Currency:</label>
          <label className="currency-label currency-label--active">USD</label>
        </div>
        <div className="top-nav__social">
          <ul className="social-list">
            {socials.map((links, index) => (
              <li key={`social-links-${index}`} className="social-list__item">
                <a href={links.urlPath} target="_blank" rel="noreferrer">
                  <Icon imgPath={links.imagePath}></Icon>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="top-nav__user">
          <RouterLink className="link" path="/help">
            <Icon imgPath="/images/icons/help-icon.png" className="icon icon--help" />
            <label>Help</label>
          </RouterLink>
          <RouterLink className="link">
            <Icon imgPath="/images/icons/retrieve-icon.png" className="icon icon--retrieve" />
            <label>Retrieve Order</label>
          </RouterLink>
          <RouterLink className="link">
            <Icon imgPath="/images/icons/login-icon.png" className="icon icon--login" />
            <label>Login</label>
          </RouterLink>
        </div>
      </div>
      <nav className="navigation">
        <RouterLink path="/" className="navigation__logo">
          <Icon imgPath="/images/visionhub-logo.png" className="logo"></Icon>
        </RouterLink>
        <ul>
          {routes.map((mainNav, index) =>
            mainNav.show ? (
              <li
                key={`main-nav-${index}`}
                className={
                  'navigation__item ' + (activeRoute.label === mainNav.label ? 'active' : '')
                }
              >
                <RouterLink path={mainNav.path}>{mainNav.label}</RouterLink>
              </li>
            ) : (
              ''
            ),
          )}
        </ul>
        <RouterLink className="cart" path="/cart">
          <sup>{orders?.length}</sup>
        </RouterLink>
        <RouterLink className="favorites" path="/favorites">
          <sup>{favorites?.length}</sup>
        </RouterLink>
      </nav>
    </>
  );
};

export default NavBar;
